(function () {
  'use strict';

  /* ============================================================
     Dreame HK desktop mega menu — v4 "1e2" (2026-08-23)
     Theme asset for [Convx -474] Menu Revamp. Replaces the v3
     multi-row grid panel with the approved 1e2 design:
     spotlight + single-row carousel.
     Design spec (high fidelity, authoritative):
       projects/dreame-hk/context/2026-08-23_megamenu-1e2-handoff/README.md
     Change spec:
       projects/dreame-hk/html/2026-08-23_megamenu-1e2-change-spec.md

     Styling lives in assets/convx-mega-menu.css (loaded in <head>
     via convx-menu-styles.liquid) — this file is DOM + behaviour
     only, so the header paints in final form before JS runs.

     Layout rules (handoff + change spec + hero rules 2026-08-23):
     - hero/spotlight comes from the collection metafield
       custom.hero_product (list of product references, emitted as
       "heroes" by ab-test-mobile-menu-data.liquid):
         one hero  -> spotlight shows it
         multiple  -> spotlight auto-rotates (5s)
         blank     -> no spotlight, rail takes the full width
       Until the metafields are filled, HERO_FALLBACK_FIRST keeps
       the old behaviour (first product = hero). Flip it to false
       to enforce the strict metafield rule.
       ?mm_hero_debug=1 previews rotation (first two products as
       heroes) on categories with no metafield yet.
     - rail = products minus heroes. rail > 4 -> carousel (arrows +
       scroll indicator); rail <= 4 -> static rail, no controls.
     - single product / no spotlight -> SAME card-rail layout as
       every other category (standardised 2026-08-23; the special
       horizontal-spotlight layout was removed).
     - 每月精選 (promo, no sub-links) -> no spotlight, 268px cards,
       CTA row above its own divider, no chips.
     - 門市據點 -> store tile row (not part of 1e2; restyled to its
       tokens for consistency).
     Fully data-driven (2026-08-23): products/prices/images from the
     convx-burger-menu linklists via the JSON snippet; card model +
     subtitle derived from the product title; badges from product
     metafields custom.product_tag_text + custom.product_tag_colour (badge
     shows only when BOTH are filled). No hardcoded product content.
     ============================================================ */

  // desktop nav title -> menu-data title. Since the nav renders from the same
  // convx linklists as the data, titles always match; kept for future overrides.
  var TITLE_ALIASES = {};

  // per-category CTA labels (default 查看全部)
  var CTA_TEXT = {
    '每月精選': '查看全部優惠'
  };

  // Product badges are DATA-DRIVEN (2026-08-23): product metafields
  // custom.product_tag_text + custom.product_tag_colour, emitted per product as
  // tag_text / tag_color by ab-test-mobile-menu-data.liquid. A badge renders
  // ONLY when both are filled. No hardcoded badge maps remain.

  // Card model/subtitle are DERIVED from the live product title (data-driven,
  // no per-product map): leading non-CJK tokens = model, the rest = subtitle.
  // e.g. 'X60 Ultra Extreme 首款雙關節機械臂掃地機器人' -> 'X60 Ultra Extreme' +
  // '首款雙關節機械臂掃地機器人'; a fully-latin title gets no subtitle.
  var CJK_RE = /[　-鿿豈-﫿]/;

  // STRICT rule active (2026-08-23, per Justin): a category shows the spotlight
  // ONLY when its collection has custom.hero_product filled. Blank -> the panel
  // renders the full-width card rail with no spotlight. Set to true only if a
  // first-product fallback is ever wanted again.
  var HERO_FALLBACK_FIRST = false;

  function resolveHeroes(item) {
    var heroes = (item.heroes || []).filter(function (h) { return h && hasRealUrl(h.url); });
    if (heroes.length) return heroes;
    var products = item.products || [];
    // rotation preview before any metafield exists: ?mm_hero_debug=1
    if (/[?&]mm_hero_debug=1/.test(window.location.search) && products.length >= 3) {
      return products.slice(0, 2);
    }
    if (HERO_FALLBACK_FIRST && products.length >= 2) return [products[0]];
    return [];
  }

  // sub-CTA chip EN kickers by pattern
  function chipKicker(title) {
    if (title.indexOf('模組') !== -1) return 'WATER MODULE';
    if (title.indexOf('配件') !== -1) return 'ACCESSORIES';
    if (title.indexOf('比較') !== -1) return 'COMPARE';
    return '';
  }

  var STORE_EN = {
    '香港旗艦店': 'HONG KONG FLAGSHIP',
    '豐澤 Fortress': 'FORTRESS COUNTERS',
    '線下零售商': 'OFFLINE RETAILERS',
    '體驗店 Demo Store': 'PRODUCT DEMO STORE',
    '澳門維修中心': 'MACAU SERVICE CENTRE'
  };

  function getMenuData() {
    var el = document.getElementById('ab-test-mobile-menu-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[convx-mega-menu] failed to parse #ab-test-mobile-menu-data', e);
      return null;
    }
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || cents === '') return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.moneyFormat).replace(/\.00$/, '');
    }
    return 'HK$' + Math.round(cents / 100).toLocaleString('en-HK');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function copyFor(product) {
    var tokens = String(product.title || '').split(' ');
    var modelTokens = [];
    for (var i = 0; i < tokens.length; i++) {
      if (CJK_RE.test(tokens[i])) break;
      modelTokens.push(tokens[i]);
    }
    var model = modelTokens.join(' ').trim();
    if (!model) return { model: product.title, sub: '' }; // title starts with CJK
    var sub = tokens.slice(modelTokens.length).join(' ').trim();
    return { model: model, sub: sub };
  }

  function hasRealUrl(url) {
    return url && url !== '#' && url !== '';
  }

  function buildDataIndex(data) {
    var index = {};
    (data.focus || []).forEach(function (item) { index[item.title] = item; });
    (data.categories || []).forEach(function (item) { index[item.title] = item; });
    return index;
  }

  function closePanel(el) {
    var hm = el.closest('header-menu');
    if (!hm) return;
    if (typeof hm.closeWithClosingClass === 'function') hm.closeWithClosingClass();
    else if (typeof hm.close === 'function') hm.close();
    else {
      var d = hm.querySelector('details[open]');
      if (d) d.removeAttribute('open');
    }
  }

  function badgeHtml(parentTitle, product, cls) {
    // render ONLY when BOTH product metafields are filled
    if (!product.tag_text || !product.tag_color) return '';
    var color = /^#[0-9a-fA-F]{3,8}$/.test(product.tag_color) ? product.tag_color : '';
    if (!color) return '';
    return '<span class="' + cls + '" style="background:' + color + '">' + escapeHtml(product.tag_text) + '</span>';
  }

  function priceHtml(product, wrapCls) {
    var hasCompare = product.compare_at_price && product.compare_at_price > product.price;
    return '<span class="' + wrapCls + '">' + formatMoney(product.price) +
      (hasCompare ? '<s><span class="visually-hidden">原價 </span>' + formatMoney(product.compare_at_price) + '</s>' : '') +
      '</span>';
  }

  function buildCard(product, parentTitle) {
    var c = copyFor(product);
    var card = document.createElement('a');
    card.className = 'mm-card';
    card.href = product.url;
    card.innerHTML =
      '<span class="mm-card__thumb">' +
      badgeHtml(parentTitle, product, 'mm-card__badge') +
      (product.image ? '<img src="' + product.image + '" alt="" loading="lazy">' : '') +
      '</span>' +
      '<span class="mm-card__title">' + escapeHtml(c.model) + '</span>' +
      (c.sub ? '<span class="mm-card__sub">' + escapeHtml(c.sub) + '</span>' : '') +
      priceHtml(product, 'mm-card__price');
    return card;
  }

  function spotlightHtml(hero, parentTitle) {
    var c = copyFor(hero);
    return '<div class="mm-spot__tags">' +
      badgeHtml(parentTitle, hero, 'mm-tag') +
      '<span class="mm-kicker">FLAGSHIP</span>' +
      '</div>' +
      '<div class="mm-spot__media">' + (hero.image ? '<img src="' + hero.image + '" alt="">' : '') + '</div>' +
      '<p class="mm-spot__title">' + escapeHtml(c.model) + '</p>' +
      (c.sub ? '<p class="mm-spot__sub">' + escapeHtml(c.sub) + '</p>' : '') +
      '<div class="mm-spot__row">' +
      priceHtml(hero, 'mm-price') +
      '<a class="mm-buy" href="' + hero.url + '">立即選購</a>' +
      '</div>';
  }

  // spotlight; auto-rotates when the metafield holds multiple heroes.
  // Rotation only advances while the panel is open, and pauses while the
  // pointer is over the spotlight (so a hovered buy button doesn't swap away).
  function buildSpotlight(heroes, parentTitle) {
    var spot = document.createElement('div');
    spot.className = 'mm-spot';
    spot.innerHTML = spotlightHtml(heroes[0], parentTitle);

    if (heroes.length > 1) {
      var i = 0;
      var hovered = false;
      spot.addEventListener('mouseenter', function () { hovered = true; });
      spot.addEventListener('mouseleave', function () { hovered = false; });
      setInterval(function () {
        var d = spot.closest('details');
        if (!d || !d.hasAttribute('open') || hovered) return;
        i = (i + 1) % heroes.length;
        spot.style.opacity = '0';
        setTimeout(function () {
          spot.innerHTML = spotlightHtml(heroes[i], parentTitle);
          spot.style.opacity = '1';
        }, 160);
      }, 5000);
    }
    return spot;
  }

  function buildHead(titleText, countText, panelRoot) {
    var head = document.createElement('div');
    head.className = 'mm-head';
    head.innerHTML =
      '<div class="mm-head__left">' +
      '<span class="mm-head__title">' + escapeHtml(titleText) + '</span>' +
      (countText ? '<span class="mm-head__count">' + escapeHtml(countText) + '</span>' : '') +
      '</div>';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'mm-close no-control-menu';
    close.setAttribute('aria-label', '關閉選單');
    close.innerHTML = '<span aria-hidden="true">✕</span> 關閉選單';
    close.addEventListener('click', function () { closePanel(panelRoot); });
    head.appendChild(close);
    return head;
  }

  function buildChips(others) {
    var chips = document.createElement('div');
    chips.className = 'mm-chips';
    others.forEach(function (o) {
      var chip = document.createElement('a');
      chip.className = 'mm-chip';
      chip.href = o.url;
      var en = chipKicker(o.title);
      chip.innerHTML =
        '<span class="mm-chip__zh">' + escapeHtml(o.title) + '</span>' +
        (en ? '<span class="mm-chip__en">' + en + '</span>' : '');
      chips.appendChild(chip);
    });
    return chips;
  }

  function buildCta(item) {
    var cta = document.createElement('a');
    cta.className = 'mm-cta';
    cta.href = item.url;
    cta.innerHTML = '<span>' + escapeHtml(CTA_TEXT[item.title] || '查看全部') + '</span><span aria-hidden="true">→</span>';
    return cta;
  }

  // mouse drag-to-scroll for the rail (touch/trackpad already scroll natively).
  // IMPORTANT: pointer capture + the dragging class start only once the pointer
  // has actually moved >5px — capturing on pointerdown retargets the eventual
  // click to the rail and card links stop being clickable.
  function enableDragScroll(rail) {
    var down = false, dragging = false, startX = 0, startLeft = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; dragging = false; moved = 0;
      startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 5) {
        dragging = true;
        rail.classList.add('mm-rail--dragging');
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (!dragging) return;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      rail.scrollLeft = startLeft - dx;
    });
    function up() {
      if (!down) return;
      down = false; dragging = false;
      rail.classList.remove('mm-rail--dragging');
      setTimeout(function () { moved = 0; }, 0);
    }
    rail.addEventListener('pointerup', up);
    rail.addEventListener('pointercancel', up);
    rail.addEventListener('click', function (e) {
      if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  // carousel: arrows + derived scroll indicator, per handoff interaction spec
  function wireCarousel(main, rail, cardWidth, totalLabel) {
    var step = (cardWidth + 16) * 2;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'mm-arrow mm-arrow--prev no-control-menu';
    prev.setAttribute('aria-label', '上一頁');
    prev.innerHTML = '←';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'mm-arrow mm-arrow--next no-control-menu';
    next.setAttribute('aria-label', '下一頁');
    next.innerHTML = '→';
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step, behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step, behavior: 'smooth' }); });
    main.appendChild(prev);
    main.appendChild(next);

    var indicator = document.createElement('div');
    indicator.className = 'mm-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.innerHTML =
      '<span class="mm-indicator__track"><span class="mm-indicator__thumb"></span></span>' +
      '<span class="mm-indicator__label">' + escapeHtml(totalLabel) + '</span>';
    var thumb = indicator.querySelector('.mm-indicator__thumb');

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) {
        indicator.style.display = 'none';
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }
      indicator.style.display = '';
      prev.style.display = '';
      next.style.display = '';
      var thumbPct = (rail.clientWidth / rail.scrollWidth) * 100;
      var offsetPct = (rail.scrollLeft / max) * (100 - thumbPct);
      thumb.style.width = thumbPct + '%';
      thumb.style.left = offsetPct + '%';
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // first sync after layout (panel may be display-hidden inside a closed details)
    requestAnimationFrame(sync);
    var d = rail.closest('details');
    if (d) d.addEventListener('toggle', function () { requestAnimationFrame(sync); });

    return indicator;
  }

  function shell() {
    var panel = document.createElement('div');
    panel.className = 'mega-menu__content gradient motion-reduce global-settings-popup mm-content';
    panel.tabIndex = -1;
    return panel;
  }

  // shared right column: head + rail (+ carousel controls) + footer
  function buildMain(item, panel, rail, opts) {
    var carousel = rail.length > 4;
    var others = opts.chips ? (item.others || []).filter(function (o) { return hasRealUrl(o.url); }) : [];
    var cardW = opts.wideCards ? 268 : 232;

    var main = document.createElement('div');
    main.className = 'mm-main';

    main.appendChild(buildHead(opts.headTitle,
      rail.length + ' 款' + (carousel ? ' · 左右滑動瀏覽' : ''), panel));

    var railEl = document.createElement('div');
    railEl.className = 'mm-rail';
    rail.forEach(function (p) { railEl.appendChild(buildCard(p, item.title)); });
    main.appendChild(railEl);
    enableDragScroll(railEl);

    if (carousel) {
      main.appendChild(wireCarousel(main, railEl, cardW, '左右滑動瀏覽全部 ' + rail.length + ' 款'));
    }

    var footer = document.createElement('div');
    footer.className = 'mm-footer' + (others.length ? '' : ' mm-footer--end');
    if (others.length) footer.appendChild(buildChips(others));
    if (hasRealUrl(item.url)) footer.appendChild(buildCta(item));
    main.appendChild(footer);

    return main;
  }

  // spotlight + rail (heroes from the metafield rules)
  function buildSpotlightPanel(item, navTitle, heroes, rail) {
    var panel = shell();
    var mm = document.createElement('div');
    mm.className = 'mm mm--spotlight';
    panel.appendChild(mm);
    mm.appendChild(buildSpotlight(heroes, item.title));
    mm.appendChild(buildMain(item, panel, rail, { headTitle: '全系列', chips: true, wideCards: false }));
    return panel;
  }

  // no spotlight: full-width rail. Used for promo (每月精選), for categories
  // whose hero metafield is blank, and for single-product categories
  // (standardised: same card language as everywhere else).
  function buildRailPanel(item, navTitle, opts) {
    var panel = shell();
    var mm = document.createElement('div');
    mm.className = 'mm mm--rail-only' + (opts.wideCards ? ' mm--wide-cards' : '');
    panel.appendChild(mm);
    mm.appendChild(buildMain(item, panel, item.products, {
      headTitle: navTitle, chips: opts.chips, wideCards: opts.wideCards
    }));
    return panel;
  }

  // stores (門市據點): tile row in 1e2 tokens
  function buildStoresPanel(item, navTitle) {
    var panel = shell();
    var mm = document.createElement('div');
    mm.className = 'mm mm--stores';
    panel.appendChild(mm);

    var others = (item.others || []).filter(function (o) { return hasRealUrl(o.url); });
    mm.appendChild(buildHead(navTitle, others.length + ' 個據點', panel));

    var grid = document.createElement('div');
    grid.className = 'mm-stores';
    others.forEach(function (o) {
      var tile = document.createElement('a');
      tile.className = 'mm-store';
      tile.href = o.url;
      tile.innerHTML =
        '<span><span class="mm-store__zh">' + escapeHtml(o.title) + '</span>' +
        (STORE_EN[o.title] ? '<span class="mm-store__en">' + STORE_EN[o.title] + '</span>' : '') + '</span>' +
        '<span class="mm-store__arrow" aria-hidden="true">→</span>';
      grid.appendChild(tile);
    });
    mm.appendChild(grid);
    return panel;
  }

  function buildPanel(item, navTitle, isFocus) {
    var products = item.products || [];
    if (!products.length) return buildStoresPanel(item, navTitle);
    if (isFocus) return buildRailPanel(item, navTitle, { wideCards: true, chips: false });

    var heroes = resolveHeroes(item);
    var heroUrls = heroes.map(function (h) { return h.url; });
    var rail = products.filter(function (p) { return heroUrls.indexOf(p.url) === -1; });

    // no heroes (metafield blank, strict mode), or heroes would leave an empty
    // rail (single-product category): standardised full-width card rail
    if (!heroes.length || !rail.length) {
      return buildRailPanel(item, navTitle, { wideCards: false, chips: true });
    }
    return buildSpotlightPanel(item, navTitle, heroes, rail);
  }

  function summaryTitle(summary) {
    var span = summary.querySelector('span');
    return span ? span.textContent.trim() : summary.textContent.trim();
  }

  function upgradeDropdowns(data) {
    var navRoot = document.querySelector('.header__inline-menu');
    if (!navRoot) {
      console.warn('[convx-mega-menu] .header__inline-menu not found — has the theme markup changed?');
      return;
    }
    var index = buildDataIndex(data);
    var focusTitles = (data.focus || []).map(function (f) { return f.title; });
    var upgraded = 0;

    navRoot.querySelectorAll('header-menu > details').forEach(function (details) {
      if (details.dataset.abDmega) return; // idempotent
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;

      var navTitle = summaryTitle(summary);
      var dataTitle = TITLE_ALIASES[navTitle] || navTitle;
      var item = index[dataTitle];
      if (!item) {
        // the desktop nav is the theme's "store" menu (store-wide, shared with
        // live, so we don't edit it); items with no entry in the convx
        // linklists (產品對比, 配件) are hidden so the nav mirrors the convx
        // menus exactly. Their links still exist as chips inside the panels.
        var li = details.closest('li');
        if (li) li.style.display = 'none';
        return;
      }

      var oldPanel = details.querySelector(':scope > .mega-menu__content, :scope > .header__submenu');
      if (!oldPanel) return;

      var panel = buildPanel(item, navTitle, focusTitles.indexOf(dataTitle) !== -1);
      oldPanel.remove();
      details.appendChild(panel);
      details.dataset.abDmega = '1';

      // HeaderMenu cached this.content at upgrade; repoint it at the new panel
      var hm = details.closest('header-menu');
      if (hm && 'content' in hm) {
        hm.content = panel;
        hm.animations = null;
      }

      // theme bug our tall panel exposes: mouseleave schedules close() on a
      // 300ms timer that re-entering NEVER cancels, so a momentary pointer
      // exit closes the menu under the cursor. Cancel the pending close on
      // re-enter (gives the ~grace delay the 1e2 handoff asks for).
      details.addEventListener('mouseenter', function () {
        if (hm && hm.closingTimeout) {
          clearTimeout(hm.closingTimeout);
          hm.closingTimeout = null;
        }
        details.classList.remove('closing');
      });
      upgraded++;
    });

    if (!upgraded) {
      console.warn('[convx-mega-menu] no dropdowns matched the menu data — check nav titles vs convx-burger-menu linklists');
    }
  }

  function refreshStickyMetrics() {
    // CSS now loads in <head>, so measurements are usually right already;
    // kept as a safety net for late font/image height shifts
    var apply = function () {
      var el = document.querySelector('sticky-header');
      if (!el) return;
      if (typeof el.onWindowResize === 'function') {
        try { el.onWindowResize(); return; } catch (e) { /* fall through */ }
      }
      window.dispatchEvent(new Event('resize'));
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('sticky-header').then(function () {
        requestAnimationFrame(apply);
      });
    } else {
      apply();
    }
    if (document.readyState === 'complete') {
      setTimeout(apply, 400);
    } else {
      window.addEventListener('load', function () { setTimeout(apply, 50); });
    }
  }

  // desktop: move search + account from the nav row into the black top bar,
  // between 查看对比 and the cart, so laptop viewports keep a single-row menu.
  // Desktop-only (mobile keeps its own header layout untouched); nodes are
  // MOVED, not cloned, so their listeners and ids stay intact.
  function moveIconsToTopBar() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var localization = document.querySelector('.header-top .header__localization');
    var cart = localization && localization.querySelector('.header__icon--cart');
    var icons = document.querySelector('.header__inner .header__icons');
    if (!localization || !cart || !icons) return;
    var search = icons.querySelector('details-modal.header__search');
    var account = icons.querySelector('.header__icon--account');
    if (search) localization.insertBefore(search, cart);
    if (account) localization.insertBefore(account, cart);
  }

  function init() {
    var data = getMenuData();
    if (!data) return;
    moveIconsToTopBar();
    upgradeDropdowns(data);
    refreshStickyMetrics();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
